import { useContext } from "@shared/hooks/useContext";
import type { ToastProps, ToastsContextType } from "@shared/toasts/ToastProvider";
import { ToastContext } from "@shared/toasts/ToastProvider";

const useFileToastsContext = (): ToastsContextType => {
  return useContext({ context: ToastContext, providerName: "Toasts" });
};

interface ToastHook {
  displayToast: (props : ToastProps) => void;
}

export const useToasts = (): ToastHook => {
  const { displayToast } = useFileToastsContext();

  return {
    displayToast
  };
};